import {FormControl, Select} from '@primer/react-brand'
import {useContext} from 'react'
import {getAnalyticsEvent} from '../../../../lib/utils/analytics'
import type {FormFieldSelect} from '../../../../schemas/contentful/contentTypes/formFieldSelect'
import {FormContext} from '../../../forms/Form/FormContext'
import {getValidation} from '../validations'
import {t} from '../../../../lib/utils/localization'

export type ContentfulSelectProps = {
  component: FormFieldSelect
}

export function ContentfulSelectInput({component: selectInput}: ContentfulSelectProps) {
  const formContext = useContext(FormContext)

  if (formContext === undefined) {
    throw new Error('ERROR: form context is undefined for ContentfulSelectInput')
  }

  const required = selectInput.fields.validations?.some(validation => validation.fields.name === 'REQUIRED') ?? false

  const validations = selectInput.fields.validations?.map(getValidation) ?? []

  const error = formContext.errors[selectInput.fields.htmlName]

  const validationErrorId = `${selectInput.fields.htmlName}-validation-msg`

  const {id, ...registerProps} = formContext.register(selectInput.fields.htmlName, {
    label: selectInput.fields.label,
    required,
    validations,
  })

  return (
    <FormControl
      key={selectInput.fields.htmlName}
      id={id}
      fullWidth
      required={required}
      validationStatus={typeof error === 'string' ? 'error' : undefined}
    >
      <FormControl.Label>{selectInput.fields.label}</FormControl.Label>
      <Select
        {...registerProps}
        {...getAnalyticsEvent({
          action: selectInput.fields.label,
          tag: 'select',
          context: 'form_control',
          location: 'form',
        })}
        aria-describedby={validationErrorId}
      >
        <option value="">{t('Select')}…</option>
        {Object.entries(selectInput.fields.options).map(([value, label]) => (
          <option key={value} value={value}>
            {label}
          </option>
        ))}
      </Select>
      {typeof error === 'string' ? (
        <FormControl.Validation id={validationErrorId}>{error}</FormControl.Validation>
      ) : null}
    </FormControl>
  )
}

try{ ContentfulSelectInput.displayName ||= 'ContentfulSelectInput' } catch {}